import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import LazyLoad from "react-lazyload";
import signature_img from "../../assets/img/collection/marquis-signature.png";
import marquis_2020 from "../../assets/img/collection/marquis-2020.png";
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function CollectionInnerProperties({ title, cards }) {


  const peropertiescards = cards
    ? JSON.parse(cards)
    : [];

  return (
    <section className="collection-sold-properties-sec whiteColorBG">
      <Container fluid>
        <div className="flex-center text-center mb-5 row">
          <div className="col-md-8">
            <div className="heading-div">
              <h1 className="common-head darkGrey">{title}</h1>

            </div>
          </div>
        </div>
        <div className="collection-sold-properties-div row">
          {peropertiescards.map((card, index) => (
            <div
              className="sold-property-card col-md-6"
              key={index}
              data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
            >
              <Link to={`/properties${card.property_link}`}>
                <img
                  src={`${apiUrl.apiUrl}/${card.image}`}
                  className="img-fluid"
                  alt={card.property_name}
                />
                <div className="sold-propery-content">
                  <h2 className="goldenColor luxury-font">
                    {card.property_name}
                  </h2>
                  <p>{card.property_description}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default CollectionInnerProperties;
